import ModalEdit from "@/components/forms/ModalEdit"

export default {
  methods: {
    modalEdit(obj, field) {
      this.$modal.open({
        parent: this,
        component: ModalEdit,
        props: { field: obj[field] },
        events: {
          update: value => {
            console.log(value)
            obj[field] = value
          }
        }
      })
    }
  }
}
